(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[93,99],{

/***/ "30+C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("wx14");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("Ff2n");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("17x9");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("iuhU");
/* harmony import */ var _Paper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("kKAo");
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("H2TA");







var styles = {
  /* Styles applied to the root element. */
  root: {
    overflow: 'hidden'
  }
};
var Card = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__["forwardRef"](function Card(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$raised = props.raised,
      raised = _props$raised === void 0 ? false : _props$raised,
      other = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(props, ["classes", "className", "raised"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__["createElement"](_Paper__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"], Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    className: Object(clsx__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"])(classes.root, className),
    elevation: raised ? 8 : 1,
    ref: ref
  }, other));
});
 false ? undefined : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(_styles_withStyles__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"])(styles, {
  name: 'MuiCard'
})(Card));

/***/ }),

/***/ "8OQS":
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;

/***/ }),

/***/ "Aiso":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("dQHF")


/***/ }),

/***/ "BPiC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("wx14");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__("/MKj");

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__("20a2");

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__("Vvt1");
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);

// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__("p46w");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// EXTERNAL MODULE: ./src/constants/breakpoints.js
var breakpoints = __webpack_require__("oTwq");

// EXTERNAL MODULE: ./src/context/breakpoints.js
var context_breakpoints = __webpack_require__("/Yzd");

// EXTERNAL MODULE: ./src/hooks/events/useEventListener.js
var useEventListener = __webpack_require__("M6j1");

// EXTERNAL MODULE: ./src/store/modules/popup_manager/actions.js
var actions = __webpack_require__("pOqu");

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__("vOnD");

// CONCATENATED MODULE: ./src/placeholders/Toolbars/Modals/CartMenu.js

var CartMenuPlaceholder = styled_components_browser_esm["b" /* default */].div.withConfig({
  displayName: "CartMenu__CartMenuPlaceholder",
  componentId: "sc-6o5q6g-0"
})(["background-color:white;width:290px;height:400px;border-radius:28px;@media only screen and (min-width:992px){width:411px;}"]);
/* harmony default export */ var CartMenu = (CartMenuPlaceholder);
// EXTERNAL MODULE: ./src/placeholders/Toolbars/Modals/UserMenu.js
var UserMenu = __webpack_require__("StEm");

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__("Aiso");
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__("YFqc");
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Badge/Badge.js
var Badge = __webpack_require__("IFCi");

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__("PsDL");

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__("5AJ6");

// CONCATENATED MODULE: ./node_modules/@material-ui/icons/esm/ExpandMore.js


/* harmony default export */ var ExpandMore = (Object(createSvgIcon["a" /* default */])( /*#__PURE__*/react["createElement"]("path", {
  d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore'));
// CONCATENATED MODULE: ./node_modules/@material-ui/icons/esm/LocalMall.js


/* harmony default export */ var LocalMall = (Object(createSvgIcon["a" /* default */])( /*#__PURE__*/react["createElement"]("path", {
  d: "M19 6h-2c0-2.76-2.24-5-5-5S7 3.24 7 6H5c-1.1 0-1.99.9-1.99 2L3 20c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-7-3c1.66 0 3 1.34 3 3H9c0-1.66 1.34-3 3-3zm0 10c-2.76 0-5-2.24-5-5h2c0 1.66 1.34 3 3 3s3-1.34 3-3h2c0 2.76-2.24 5-5 5z"
}), 'LocalMall'));
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/AccountCircle.js
var AccountCircle = __webpack_require__("ckIp");

// EXTERNAL MODULE: ./src/atomic/common/Buttons/index.js
var Buttons = __webpack_require__("fBnl");

// EXTERNAL MODULE: ./src/atomic/common/Containers/DesktopOnly.js
var DesktopOnly = __webpack_require__("OHIw");

// EXTERNAL MODULE: ./src/atomic/common/Containers/MobileOnly.js
var MobileOnly = __webpack_require__("1lfy");

// EXTERNAL MODULE: ./src/atomic/organisms/MapCard/index.js
var MapCard = __webpack_require__("jmHE");

// EXTERNAL MODULE: ./src/atomic/organisms/PopupManager/index.js
var PopupManager = __webpack_require__("MVkE");

// EXTERNAL MODULE: ./src/atomic/organisms/ProtectRoute/index.js + 1 modules
var ProtectRoute = __webpack_require__("HkjM");

// EXTERNAL MODULE: ./src/atomic/organisms/SearchBar/index.js + 5 modules
var SearchBar = __webpack_require__("KwoO");

// CONCATENATED MODULE: ./src/atomic/organisms/index.js




// EXTERNAL MODULE: ./src/atomic/globals/index.js + 3 modules
var globals = __webpack_require__("BlcV");

// CONCATENATED MODULE: ./src/atomic/pages/Toolbar/styles.js



var Container = styled_components_browser_esm["b" /* default */].div.withConfig({
  displayName: "styles__Container",
  componentId: "fut6tp-0"
})(["position:relative;z-index:1000;background-color:#faf8f8;width:100%;box-shadow:0px 10px 34px rgba(0,0,0,0.08);padding:15px 20px;display:flex;flex-direction:column;@media only screen and (min-width:900px){padding:20px 40px;}"]);
var Grid = styled_components_browser_esm["b" /* default */].div.withConfig({
  displayName: "styles__Grid",
  componentId: "fut6tp-1"
})(["width:100%;display:grid;grid-template-columns:1fr 1fr;&:not(:last-child){margin-bottom:15px;}& > div{display:flex;align-items:center;}& > div:nth-child(2){justify-content:flex-end;}@media only screen and (min-width:900px){display:grid;grid-template-columns:54% 46%;&:not(:last-child){margin-bottom:0;}}", ""], function (props) {
  return !props.hasButtonLogin && Object(styled_components_browser_esm["a" /* css */])(["@media (max-width:899px){margin-bottom:25px !important;}"]);
});
var Logo = Object(styled_components_browser_esm["b" /* default */])(image_default.a).withConfig({
  displayName: "styles__Logo",
  componentId: "fut6tp-2"
})(["cursor:pointer;width:100px;height:auto;@media only screen and (min-width:900px){width:120px;margin-right:15px;}"]);
var SelectArea = styled_components_browser_esm["b" /* default */].div.withConfig({
  displayName: "styles__SelectArea",
  componentId: "fut6tp-3"
})(["background-color:white;margin-right:15px;border-radius:22px;box-shadow:0 14px 15px 0 rgba(0,0,0,0.03);padding:10px 15px;display:flex;align-items:center;& > img{width:18px;height:18px;}p{margin-left:18px;}"]);
var Address = styled_components_browser_esm["b" /* default */].p.withConfig({
  displayName: "styles__Address",
  componentId: "fut6tp-4"
})(["max-width:150px;margin-right:15px;color:#424242;font-family:", ";font-size:", ";white-space:nowrap;text-overflow:ellipsis;overflow:hidden;"], globals["b" /* FONTS */].family.roboto_medium, globals["b" /* FONTS */].size.small);
var PopUpMenu = styled_components_browser_esm["b" /* default */].div.withConfig({
  displayName: "styles__PopUpMenu",
  componentId: "fut6tp-5"
})(["position:absolute;z-index:9999;top:", ";", " ", " ", " @media (max-width:425px){right:auto;}"], function (props) {
  return props.top ? props.top : 0;
}, function (props) {
  return !!props.left && props.left && Object(styled_components_browser_esm["a" /* css */])(["left:", ";"], props.left);
}, function (props) {
  return !!props.right && props.right && Object(styled_components_browser_esm["a" /* css */])(["right:", ";"], props.right);
}, function (props) {
  return !!props.align && props.align && Object(styled_components_browser_esm["a" /* css */])(["transform:translate(-100%,0);"]);
});
var CreateStore = styled_components_browser_esm["b" /* default */].span.withConfig({
  displayName: "styles__CreateStore",
  componentId: "fut6tp-6"
})(["color:#878585;font-family:", ";font-size:13px;cursor:pointer;margin-top:4px;position:absolute;bottom:10px;@media (max-width:899px){bottom:0px;top:60px;}"], globals["b" /* FONTS */].family.roboto_medium);
var Column = styled_components_browser_esm["b" /* default */].div.withConfig({
  displayName: "styles__Column",
  componentId: "fut6tp-7"
})(["display:flex;flex-direction:column;align-items:center;margin-left:26px;"]);
// CONCATENATED MODULE: ./src/atomic/pages/Toolbar/index.js


var __jsx = react_default.a.createElement;

/* eslint-disable react-hooks/rules-of-hooks */






















var Toolbar_CartMenu = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(0), __webpack_require__.e(13), __webpack_require__.e(140)]).then(__webpack_require__.bind(null, "bnvQ"));
}, {
  loading: function loading() {
    return __jsx(CartMenu, null);
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("bnvQ")];
    },
    modules: ["@@/organisms/Toolbar/CartMenu"]
  }
});
var Toolbar_UserMenu = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(0), __webpack_require__.e(13)]).then(__webpack_require__.bind(null, "dtfp"));
}, {
  loading: function loading() {
    return __jsx(UserMenu["a" /* default */], null);
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("dtfp")];
    },
    modules: ["@@/organisms/Toolbar/UserMenu"]
  }
});

var Toolbar_Toolbar = function Toolbar() {
  var tokenCookies = js_cookie_default.a.get("token");

  var _useState = Object(react["useState"])(null),
      token = _useState[0],
      setToken = _useState[1];

  Object(react["useEffect"])(function () {
    setToken(tokenCookies);
  }, [tokenCookies]);

  var _useContext = Object(react["useContext"])(context_breakpoints["a" /* default */]),
      currentMatch = _useContext.currentMatch;

  var layoutMiddle = currentMatch[1] < breakpoints["a" /* DEFAULT_BREAKPOINTS */].lg;
  var layoutMobile = currentMatch[1] < breakpoints["a" /* DEFAULT_BREAKPOINTS */].md;
  var anchorRef = Object(react["useRef"])();
  var popUpRef = Object(react["useRef"])();

  var _useState2 = Object(react["useState"])(null),
      popUpType = _useState2[0],
      setPopUpType = _useState2[1];

  var _useState3 = Object(react["useState"])({}),
      popUpPos = _useState3[0],
      setPopUpPos = _useState3[1];

  var _useSelector = Object(es["d" /* useSelector */])(function (state) {
    return state.root;
  }),
      _coords = _useSelector.coords,
      _cart = _useSelector.cart;

  var dispatch = Object(es["c" /* useDispatch */])();
  var router = Object(next_router["useRouter"])();
  Object(react["useEffect"])(function () {
    if (!!popUpType && !!anchorRef.current) {
      var pos = {};
      var _anchorRef$current = anchorRef.current,
          offsetTop = _anchorRef$current.offsetTop,
          offsetLeft = _anchorRef$current.offsetLeft,
          offsetWidth = _anchorRef$current.offsetWidth,
          offsetHeight = _anchorRef$current.offsetHeight;
      pos.top = "".concat(offsetTop + offsetHeight, "px");

      if (offsetLeft > window.innerWidth / 2) {
        pos.right = "".concat(window.innerWidth - offsetLeft - offsetWidth, "px");
      } else {
        pos.left = "".concat(offsetLeft, "px");
      }

      setPopUpPos(pos);
    }
  }, [anchorRef, popUpType, layoutMiddle, layoutMobile]);
  var handleClickOutside = Object(react["useCallback"])(function (e) {
    if (anchorRef.current && !anchorRef.current.contains(e.target) && popUpRef.current && !popUpRef.current.contains(e.target)) {
      anchorRef.current = null;
      popUpRef.current = null;
      setPopUpType(null);
    }
  }, [anchorRef, popUpRef]);

  if (true) {
    Object(useEventListener["a" /* default */])("click", handleClickOutside, document);
  }

  var openAddressDialog = function openAddressDialog() {
    dispatch(Object(actions["i" /* setType */])("select-area"));
  };

  var openCart = function openCart(event) {
    if (_cart.length > 0) {
      if (layoutMobile) {
        router.push("/carrinho");
      } else {
        anchorRef.current = event.currentTarget;
        setPopUpType("cart");
      }
    } else {
      router.push("/carrinho");
    }
  };

  var openPopUpMenu = function openPopUpMenu(event, type) {
    anchorRef.current = event.currentTarget;
    setPopUpType(type);
  };

  var renderPopUpMenu = function renderPopUpMenu() {
    switch (popUpType) {
      case "cart":
        return __jsx(PopUpMenu, Object(esm_extends["a" /* default */])({
          ref: popUpRef
        }, popUpPos), __jsx(Toolbar_CartMenu, {
          closeMenu: function closeMenu() {
            return setPopUpType(null);
          }
        }));

      case "user":
        if (layoutMobile) {
          return __jsx(Toolbar_UserMenu, {
            closeMenu: function closeMenu() {
              return setPopUpType(null);
            }
          });
        }

        return __jsx(PopUpMenu, Object(esm_extends["a" /* default */])({
          ref: popUpRef
        }, popUpPos), __jsx(Toolbar_UserMenu, {
          closeMenu: function closeMenu() {
            return setPopUpType(null);
          }
        }));

      default:
        return null;
    }
  };

  return __jsx(Container, null, renderPopUpMenu(), __jsx(Grid, {
    hasButtonLogin: !!token
  }, __jsx("div", null, __jsx("a", {
    style: {
      outline: "none",
      marginRight: 15
    },
    href: "/"
  }, __jsx(Logo, {
    src: "/images/logotipo-dolado-blue.svg",
    alt: "dolado",
    height: "29px",
    width: layoutMiddle ? "100px" : "120px"
  })), __jsx(DesktopOnly["a" /* default */], {
    direction: "row",
    flexGrow: true
  }, __jsx(SearchBar["a" /* default */], {
    search: "all",
    placeholder: "Busque por lojas ou produtos"
  }))), __jsx("div", null, __jsx(DesktopOnly["a" /* default */], {
    direction: "row"
  }, __jsx(SelectArea, null, __jsx(image_default.a, {
    width: layoutMiddle ? "24px" : "18px",
    height: layoutMiddle ? "24px" : "18px",
    src: "/icons/pin.png",
    alt: "pin"
  }), __jsx(Address, null, _coords && _coords.address && _coords.address.length ? _coords.address.split(",")[0] : "Brasil"), __jsx(IconButton["a" /* default */], {
    id: "toolbar-select-address-icon",
    "aria-label": "Navegar por regi\xF5es",
    size: "small",
    onClick: openAddressDialog
  }, __jsx(ExpandMore, null)))), __jsx(MobileOnly["a" /* default */], {
    direction: "row"
  }, __jsx(IconButton["a" /* default */], {
    id: "toolbar-select-address-icon-mobile",
    "aria-label": "Navegar por regi\xF5es",
    size: "small",
    onClick: openAddressDialog,
    style: {
      marginRight: 25
    }
  }, __jsx(image_default.a, {
    width: layoutMiddle ? "24px" : "18px",
    height: layoutMiddle ? "24px" : "18px",
    src: "/icons/pin.png",
    alt: "pin"
  }))), __jsx(IconButton["a" /* default */], {
    id: "toolbar-cart-icon",
    onClick: openCart
  }, __jsx(Badge["a" /* default */], {
    badgeContent: _cart.length,
    color: "primary"
  }, __jsx(LocalMall, null))), token ? __jsx(react_default.a.Fragment, null, __jsx("span", null, "|"), __jsx(IconButton["a" /* default */], {
    id: "toolbar-user-icon",
    onClick: function onClick(e) {
      return openPopUpMenu(e, "user");
    }
  }, __jsx(AccountCircle["a" /* default */], null))) : __jsx(link_default.a, {
    hreflang: "pt-BR",
    href: "/login"
  }, __jsx(Column, null, __jsx(Buttons["b" /* default */], {
    id: "botao-entrar",
    btnWidth: true,
    btnHeight: 44,
    btnDesktopWidth: 100,
    btnBorderRadius: 12,
    bgColor: "#1c6bf7"
  }, __jsx(Buttons["a" /* CustomButtonText */], {
    fontSize: 12,
    fontDesktopSize: 14,
    style: {
      fontFamily: globals["b" /* FONTS */].family.roboto_bold,
      fontWeight: "normal"
    }
  }, "ENTRAR")), __jsx(CreateStore, null, "criar loja gr\xE1tis"))))), __jsx(MobileOnly["a" /* default */], null, __jsx(SearchBar["a" /* default */], {
    search: "all",
    placeholder: "Busque por lojas ou produtos"
  })));
};

/* harmony default export */ var pages_Toolbar = __webpack_exports__["default"] = (Toolbar_Toolbar);

/***/ }),

/***/ "HkjM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("wx14");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__("20a2");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("o0o1");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("Ff2n");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("HaE+");

// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__("p46w");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__("/MKj");

// EXTERNAL MODULE: ./src/helpers/index.js + 24 modules
var helpers = __webpack_require__("zpb6");

// EXTERNAL MODULE: ./src/hooks/lifecicle/useWaitHydration.js
var useWaitHydration = __webpack_require__("XXxy");

// CONCATENATED MODULE: ./src/hooks/session/useAuth.js








function useAuth() {
  var permissions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var isCompany = arguments.length > 1 ? arguments[1] : undefined;
  var token = js_cookie_default.a.get("token");

  var _useState = Object(react["useState"])(true),
      loading = _useState[0],
      setLoading = _useState[1];

  var _useState2 = Object(react["useState"])(null),
      isAuthenticated = _useState2[0],
      setIsAuthenticated = _useState2[1];

  var _useState3 = Object(react["useState"])(null),
      authData = _useState3[0],
      setAuthData = _useState3[1];

  var _useSelector = Object(es["d" /* useSelector */])(function (state) {
    return state.root;
  }),
      user_group = _useSelector.user_group,
      isCompanyFromRedux = _useSelector.isCompany;

  var fetchValidation = Object(react["useCallback"])(function () {
    Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var _yield$validateSessio, valid, data;

      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoading(true);

              if (!(token && token !== "")) {
                _context.next = 10;
                break;
              }

              _context.next = 4;
              return Object(helpers["x" /* validateSession */])(user_group, permissions);

            case 4:
              _yield$validateSessio = _context.sent;
              valid = _yield$validateSessio.valid;
              data = Object(objectWithoutProperties["a" /* default */])(_yield$validateSessio, ["valid"]);

              if (valid) {
                setAuthData(data);

                if (isCompany && !isCompanyFromRedux) {
                  setIsAuthenticated(false);
                } else {
                  setIsAuthenticated(true);
                }
              } else {
                setIsAuthenticated(false);
              }

              _context.next = 11;
              break;

            case 10:
              setIsAuthenticated(false);

            case 11:
              setLoading(false);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }, [token, user_group, permissions, isCompany, isCompanyFromRedux]);
  Object(useWaitHydration["a" /* default */])(fetchValidation);
  return {
    loading: loading,
    isAuthenticated: isAuthenticated,
    authData: authData
  };
}
// CONCATENATED MODULE: ./src/atomic/organisms/ProtectRoute/index.js


var __jsx = react_default.a.createElement;

/* eslint-disable react-hooks/rules-of-hooks */




var ProtectRoute_ProtectRoute = function ProtectRoute(Component) {
  var isCompany = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var permissions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var customFallback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {
    return {};
  };
  return function (props) {
    var _customFallback = customFallback(),
        action = _customFallback.action,
        isReady = _customFallback.isReady;

    var _useAuth = useAuth(permissions, isCompany),
        loading = _useAuth.loading,
        isAuthenticated = _useAuth.isAuthenticated,
        authData = _useAuth.authData;

    var router = Object(next_router["useRouter"])();
    Object(react["useEffect"])(function () {
      if (!isAuthenticated && !loading) {
        if (isReady !== undefined) {
          if (isReady) action();
        } else {
          router.push("/login");
        }
      }
    }, [loading, isAuthenticated, action, isReady, router]);
    return __jsx(Component, Object(esm_extends["a" /* default */])({}, props, {
      auth: !loading && isAuthenticated,
      authData: authData
    }));
  };
};

/* harmony default export */ var organisms_ProtectRoute = __webpack_exports__["a"] = (ProtectRoute_ProtectRoute);

/***/ }),

/***/ "MVkE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("/MKj");
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("Vvt1");
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _store_modules_popup_manager_actions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("pOqu");

var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;



var AddPromotion = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(0), __webpack_require__.e(3), __webpack_require__.e(11), __webpack_require__.e(12), __webpack_require__.e(80)]).then(__webpack_require__.bind(null, "K0Ef"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("K0Ef")];
    },
    modules: ["@@/molecules/AddPromotion"]
  }
});
var Alert = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(0), __webpack_require__.e(11), __webpack_require__.e(107)]).then(__webpack_require__.bind(null, "4Wd8"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("4Wd8")];
    },
    modules: ["@@/molecules/Alert"]
  }
});
var LocationOff = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(0), __webpack_require__.e(11), __webpack_require__.e(16), __webpack_require__.e(120)]).then(__webpack_require__.bind(null, "pYuZ"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("pYuZ")];
    },
    modules: ["@@/molecules/LocationOff"]
  }
});
var SelectArea = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(0), __webpack_require__.e(11), __webpack_require__.e(16), __webpack_require__.e(110)]).then(__webpack_require__.bind(null, "TYYV"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("TYYV")];
    },
    modules: ["@@/molecules/SelectArea"]
  }
});
var SignUpStoreSuccess = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(0), __webpack_require__.e(11), __webpack_require__.e(16), __webpack_require__.e(118)]).then(__webpack_require__.bind(null, "USb1"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("USb1")];
    },
    modules: ["@@/molecules/SignUpStoreSuccess"]
  }
});
var SignUpSuccess = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(0), __webpack_require__.e(11), __webpack_require__.e(16), __webpack_require__.e(119)]).then(__webpack_require__.bind(null, "52b3"));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("52b3")];
    },
    modules: ["@@/molecules/SignUpSuccess"]
  }
});

var PopupManager = function PopupManager() {
  var _useSelector = Object(react_redux__WEBPACK_IMPORTED_MODULE_1__[/* useSelector */ "d"])(function (state) {
    return state.popup_manager;
  }),
      _type = _useSelector.type,
      _message = _useSelector.message,
      _data = _useSelector.data;

  var dispatch = Object(react_redux__WEBPACK_IMPORTED_MODULE_1__[/* useDispatch */ "c"])();

  var closePopup = function closePopup() {
    dispatch(Object(_store_modules_popup_manager_actions__WEBPACK_IMPORTED_MODULE_3__[/* setType */ "i"])(null));
  };

  var goBackSelectArea = function goBackSelectArea() {
    dispatch(Object(_store_modules_popup_manager_actions__WEBPACK_IMPORTED_MODULE_3__[/* setType */ "i"])("select-area"));
  };

  var resetAlert = function resetAlert() {
    dispatch(Object(_store_modules_popup_manager_actions__WEBPACK_IMPORTED_MODULE_3__[/* resetPopup */ "h"])());
  };

  switch (_type) {
    case "alert":
      return __jsx(Alert, {
        type: _data.type,
        imageSrc: _data.photo,
        errorMessage: _message,
        callback: resetAlert,
        duration: _data.duration
      });

    case "add-promotion":
      return __jsx(AddPromotion, {
        initProducts: _data.products,
        callback: closePopup
      });

    case "location-off":
      return __jsx(LocationOff, {
        goBackCB: goBackSelectArea,
        closeCB: closePopup
      });

    case "select-area":
      return __jsx(SelectArea, {
        callback: closePopup
      });

    case "sign-up":
      return __jsx(SignUpSuccess, {
        name: _message,
        closeCB: closePopup
      });

    case "sign-up-store":
      return __jsx(SignUpStoreSuccess, {
        name: _message,
        closeCB: closePopup
      });

    default:
      return null;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (PopupManager);

/***/ }),

/***/ "PcuG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("wx14");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("Ff2n");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("vOnD");
/* harmony import */ var _material_ui_core_Card__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("30+C");


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;



var CustomCard = Object(styled_components__WEBPACK_IMPORTED_MODULE_3__[/* default */ "b"])(_material_ui_core_Card__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"]).withConfig({
  displayName: "DefaultCard__CustomCard",
  componentId: "cfl7w6-0"
})(["&&{background-color:#ffffff;box-shadow:", ";display:flex;flex-direction:column;justify-content:flex-start;width:", ";", " margin:", ";border-radius:", ";padding:", ";position:relative;}"], function (props) {
  return props.shadow ? "0 4px 10px 0 rgba(0,0,0,0.04)" : "none";
}, function (props) {
  return props.width ? props.width : "max-content";
}, function (props) {
  return props.height ? "height: ".concat(props.height, ";") : "";
}, function (props) {
  return props.margin ? props.margin : "0";
}, function (props) {
  return props.radius ? props.radius : "42px";
}, function (props) {
  return props.padding ? props.padding : "0";
});

var DefaultCard = function DefaultCard(_ref) {
  var children = _ref.children,
      rest = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["children"]);

  return __jsx(CustomCard, Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({}, rest, {
    "data-testid": "default-card-component"
  }), children);
};

DefaultCard.defaultProps = {
  children: "Card"
};
/* harmony default export */ __webpack_exports__["a"] = (DefaultCard);

/***/ }),

/***/ "StEm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("vOnD");

var UserMenuPlaceholder = styled_components__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"].div.withConfig({
  displayName: "UserMenu__UserMenuPlaceholder",
  componentId: "sc-1qu23iv-0"
})(["background-color:rgba(0,0,0,0.2);position:absolute;overflow-y:auto;z-index:9999;left:0;top:0;width:100%;height:100vh;@media only screen and (min-width:768px){position:relative;background-color:white;width:260px;height:400px;border-radius:28px;}@media only screen and (min-width:992px){width:350px;}"]);
/* harmony default export */ __webpack_exports__["a"] = (UserMenuPlaceholder);

/***/ }),

/***/ "UWYU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
exports.__esModule=true;exports.imageConfigDefault=exports.VALID_LOADERS=void 0;const VALID_LOADERS=['default','imgix','cloudinary','akamai'];exports.VALID_LOADERS=VALID_LOADERS;const imageConfigDefault={deviceSizes:[640,750,828,1080,1200,1920,2048,3840],imageSizes:[16,32,48,64,96,128,256,384],path:'/_next/image',loader:'default',domains:[]};exports.imageConfigDefault=imageConfigDefault;
//# sourceMappingURL=image-config.js.map

/***/ }),

/***/ "ckIp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("5AJ6");


/* harmony default export */ __webpack_exports__["a"] = (Object(_utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"
}), 'AccountCircle'));

/***/ }),

/***/ "dEHY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.toBase64 = toBase64;
/**
* Isomorphic base64 that works on the server and client
*/

function toBase64(str) {
  if (false) {} else {
    return window.btoa(str);
  }
}

/***/ }),

/***/ "dQHF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = __webpack_require__("J4zp");

var _toConsumableArray = __webpack_require__("RIqP");

var _interopRequireDefault = __webpack_require__("TqRt");

exports.__esModule = true;
exports.default = Image;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__("8OQS"));

var _extends2 = _interopRequireDefault(__webpack_require__("pVnL"));

var _react = _interopRequireDefault(__webpack_require__("q1tI"));

var _toBase = __webpack_require__("dEHY");

var _imageConfig = __webpack_require__("UWYU");

var _useIntersection = __webpack_require__("vNVm");

if (false) {}

var VALID_LOADING_VALUES = ['lazy', 'eager', undefined];
var loaders = new Map([['imgix', imgixLoader], ['cloudinary', cloudinaryLoader], ['akamai', akamaiLoader], ['default', defaultLoader]]);
var VALID_LAYOUT_VALUES = ['fill', 'fixed', 'intrinsic', 'responsive', undefined];

var _ref2 = {"deviceSizes":[640,750,828,1080,1200,1920,2048,3840],"imageSizes":[16,32,48,64,96,128,256,384],"path":"/_next/image","loader":"default"} || _imageConfig.imageConfigDefault,
    configDeviceSizes = _ref2.deviceSizes,
    configImageSizes = _ref2.imageSizes,
    configLoader = _ref2.loader,
    configPath = _ref2.path,
    configDomains = _ref2.domains; // sort smallest to largest


var allSizes = [].concat(_toConsumableArray(configDeviceSizes), _toConsumableArray(configImageSizes));
configDeviceSizes.sort(function (a, b) {
  return a - b;
});
allSizes.sort(function (a, b) {
  return a - b;
});

function getWidths(width, layout) {
  if (typeof width !== 'number' || layout === 'fill' || layout === 'responsive') {
    return {
      widths: configDeviceSizes,
      kind: 'w'
    };
  }

  var widths = _toConsumableArray(new Set([width, width * 2, width * 3].map(function (w) {
    return allSizes.find(function (p) {
      return p >= w;
    }) || allSizes[allSizes.length - 1];
  })));

  return {
    widths: widths,
    kind: 'x'
  };
}

function callLoader(loaderProps) {
  var load = loaders.get(configLoader);

  if (load) {
    return load((0, _extends2.default)({
      root: configPath
    }, loaderProps));
  }

  throw new Error("Unknown \"loader\" found in \"next.config.js\". Expected: ".concat(_imageConfig.VALID_LOADERS.join(', '), ". Received: ").concat(configLoader));
}

function generateImgAttrs(_ref3) {
  var src = _ref3.src,
      unoptimized = _ref3.unoptimized,
      layout = _ref3.layout,
      width = _ref3.width,
      quality = _ref3.quality,
      sizes = _ref3.sizes;

  if (unoptimized) {
    return {
      src: src
    };
  }

  var _getWidths = getWidths(width, layout),
      widths = _getWidths.widths,
      kind = _getWidths.kind;

  var last = widths.length - 1;
  var srcSet = widths.map(function (w, i) {
    return "".concat(callLoader({
      src: src,
      quality: quality,
      width: w
    }), " ").concat(kind === 'w' ? w : i + 1).concat(kind);
  }).join(', ');

  if (!sizes && kind === 'w') {
    sizes = '100vw';
  }

  src = callLoader({
    src: src,
    quality: quality,
    width: widths[last]
  });
  return {
    src: src,
    sizes: sizes,
    srcSet: srcSet
  };
}

function getInt(x) {
  if (typeof x === 'number') {
    return x;
  }

  if (typeof x === 'string') {
    return parseInt(x, 10);
  }

  return undefined;
}

function Image(_ref) {
  var src = _ref.src,
      sizes = _ref.sizes,
      _ref$unoptimized = _ref.unoptimized,
      unoptimized = _ref$unoptimized === void 0 ? false : _ref$unoptimized,
      _ref$priority = _ref.priority,
      priority = _ref$priority === void 0 ? false : _ref$priority,
      loading = _ref.loading,
      className = _ref.className,
      quality = _ref.quality,
      width = _ref.width,
      height = _ref.height,
      objectFit = _ref.objectFit,
      objectPosition = _ref.objectPosition,
      all = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["src", "sizes", "unoptimized", "priority", "loading", "className", "quality", "width", "height", "objectFit", "objectPosition"]);
  var rest = all;
  var layout = sizes ? 'responsive' : 'intrinsic';
  var unsized = false;

  if ('unsized' in rest) {
    unsized = Boolean(rest.unsized); // Remove property so it's not spread into image:

    delete rest['unsized'];
  } else if ('layout' in rest) {
    // Override default layout if the user specified one:
    if (rest.layout) layout = rest.layout; // Remove property so it's not spread into image:

    delete rest['layout'];
  }

  if (false) {}

  var isLazy = !priority && (loading === 'lazy' || typeof loading === 'undefined');

  if (src && src.startsWith('data:')) {
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
    unoptimized = true;
    isLazy = false;
  }

  var _ref4 = (0, _useIntersection.useIntersection)({
    rootMargin: '200px',
    disabled: !isLazy
  }),
      _ref5 = _slicedToArray(_ref4, 2),
      setRef = _ref5[0],
      isIntersected = _ref5[1];

  var isVisible = !isLazy || isIntersected;
  var widthInt = getInt(width);
  var heightInt = getInt(height);
  var qualityInt = getInt(quality);
  var wrapperStyle;
  var sizerStyle;
  var sizerSvg;
  var imgStyle = {
    visibility: isVisible ? 'visible' : 'hidden',
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    boxSizing: 'border-box',
    padding: 0,
    border: 'none',
    margin: 'auto',
    display: 'block',
    width: 0,
    height: 0,
    minWidth: '100%',
    maxWidth: '100%',
    minHeight: '100%',
    maxHeight: '100%',
    objectFit: objectFit,
    objectPosition: objectPosition
  };

  if (typeof widthInt !== 'undefined' && typeof heightInt !== 'undefined' && layout !== 'fill') {
    // <Image src="i.png" width="100" height="100" />
    var quotient = heightInt / widthInt;
    var paddingTop = isNaN(quotient) ? '100%' : "".concat(quotient * 100, "%");

    if (layout === 'responsive') {
      // <Image src="i.png" width="100" height="100" layout="responsive" />
      wrapperStyle = {
        display: 'block',
        overflow: 'hidden',
        position: 'relative',
        boxSizing: 'border-box',
        margin: 0
      };
      sizerStyle = {
        display: 'block',
        boxSizing: 'border-box',
        paddingTop: paddingTop
      };
    } else if (layout === 'intrinsic') {
      // <Image src="i.png" width="100" height="100" layout="intrinsic" />
      wrapperStyle = {
        display: 'inline-block',
        maxWidth: '100%',
        overflow: 'hidden',
        position: 'relative',
        boxSizing: 'border-box',
        margin: 0
      };
      sizerStyle = {
        boxSizing: 'border-box',
        display: 'block',
        maxWidth: '100%'
      };
      sizerSvg = "<svg width=\"".concat(widthInt, "\" height=\"").concat(heightInt, "\" xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\"/>");
    } else if (layout === 'fixed') {
      // <Image src="i.png" width="100" height="100" layout="fixed" />
      wrapperStyle = {
        overflow: 'hidden',
        boxSizing: 'border-box',
        display: 'inline-block',
        position: 'relative',
        width: widthInt,
        height: heightInt
      };
    }
  } else if (typeof widthInt === 'undefined' && typeof heightInt === 'undefined' && layout === 'fill') {
    // <Image src="i.png" layout="fill" />
    wrapperStyle = {
      display: 'block',
      overflow: 'hidden',
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      boxSizing: 'border-box',
      margin: 0
    };
  } else {
    // <Image src="i.png" />
    if (false) {}
  }

  var imgAttributes = {
    src: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
  };

  if (isVisible) {
    imgAttributes = generateImgAttrs({
      src: src,
      unoptimized: unoptimized,
      layout: layout,
      width: widthInt,
      quality: qualityInt,
      sizes: sizes
    });
  }

  if (unsized) {
    wrapperStyle = undefined;
    sizerStyle = undefined;
    imgStyle = undefined;
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    style: wrapperStyle
  }, sizerStyle ? /*#__PURE__*/_react.default.createElement("div", {
    style: sizerStyle
  }, sizerSvg ? /*#__PURE__*/_react.default.createElement("img", {
    style: {
      maxWidth: '100%',
      display: 'block'
    },
    alt: "",
    "aria-hidden": true,
    role: "presentation",
    src: "data:image/svg+xml;base64,".concat((0, _toBase.toBase64)(sizerSvg))
  }) : null) : null, /*#__PURE__*/_react.default.createElement("img", Object.assign({}, rest, imgAttributes, {
    decoding: "async",
    className: className,
    ref: setRef,
    style: imgStyle
  })));
} //BUILT IN LOADERS


function normalizeSrc(src) {
  return src[0] === '/' ? src.slice(1) : src;
}

function imgixLoader(_ref6) {
  var root = _ref6.root,
      src = _ref6.src,
      width = _ref6.width,
      quality = _ref6.quality;
  // Demo: https://static.imgix.net/daisy.png?format=auto&fit=max&w=300
  var params = ['auto=format', 'fit=max', 'w=' + width];
  var paramsString = '';

  if (quality) {
    params.push('q=' + quality);
  }

  if (params.length) {
    paramsString = '?' + params.join('&');
  }

  return "".concat(root).concat(normalizeSrc(src)).concat(paramsString);
}

function akamaiLoader(_ref7) {
  var root = _ref7.root,
      src = _ref7.src,
      width = _ref7.width;
  return "".concat(root).concat(normalizeSrc(src), "?imwidth=").concat(width);
}

function cloudinaryLoader(_ref8) {
  var root = _ref8.root,
      src = _ref8.src,
      width = _ref8.width,
      quality = _ref8.quality;
  // Demo: https://res.cloudinary.com/demo/image/upload/w_300,c_limit,q_auto/turtles.jpg
  var params = ['f_auto', 'c_limit', 'w_' + width, 'q_' + (quality || 'auto')];
  var paramsString = params.join(',') + '/';
  return "".concat(root).concat(paramsString).concat(normalizeSrc(src));
}

function defaultLoader(_ref9) {
  var root = _ref9.root,
      src = _ref9.src,
      width = _ref9.width,
      quality = _ref9.quality;

  if (false) { var parsedSrc, missingValues; }

  return "".concat(root, "?url=").concat(encodeURIComponent(src), "&w=").concat(width, "&q=").concat(quality || 75);
}

/***/ }),

/***/ "jmHE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _hooks_events_useEventListener__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("M6j1");
/* harmony import */ var _atoms_GoogleMap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("w+tp");
/* harmony import */ var _molecules_BannerInfoCard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("q9b2");

var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;





var MapCard = function MapCard(_ref) {
  var coords = _ref.coords,
      callback = _ref.callback;

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(false),
      layoutMobile = _useState[0],
      setLayouyMobile = _useState[1];

  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    setLayouyMobile(window.innerWidth <= 600);
  }, []);
  var handleResize = Object(react__WEBPACK_IMPORTED_MODULE_0__["useCallback"])(function () {
    if (window.innerWidth > 600) {
      if (layoutMobile) {
        setLayouyMobile(false);
      }
    } else if (!layoutMobile) {
      setLayouyMobile(true);
    }
  }, [layoutMobile, setLayouyMobile]);
  Object(_hooks_events_useEventListener__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])("resize", handleResize);
  return __jsx(_molecules_BannerInfoCard__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"], {
    actionText: "Ver Mapa",
    actionCallback: callback,
    cardW: layoutMobile ? "320px" : "420px",
    cardH: layoutMobile ? "190px" : "250px",
    border: "20px",
    bannerNode: __jsx(_atoms_GoogleMap__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"], {
      width: "100%",
      height: "100%",
      coords: coords
    }),
    bannerH: layoutMobile ? "125px" : "185px"
  });
};

/* harmony default export */ __webpack_exports__["a"] = (MapCard);

/***/ }),

/***/ "pVnL":
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;

/***/ }),

/***/ "q9b2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Divider/Divider.js
var Divider = __webpack_require__("wb2y");

// EXTERNAL MODULE: ./src/atomic/atoms/DefaultCard/index.js
var DefaultCard = __webpack_require__("PcuG");

// EXTERNAL MODULE: ./src/atomic/atoms/DefaultTitle/index.js
var DefaultTitle = __webpack_require__("gFoV");

// EXTERNAL MODULE: ./src/atomic/atoms/ImageFrame/index.js + 1 modules
var ImageFrame = __webpack_require__("l6Rm");

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__("vOnD");

// CONCATENATED MODULE: ./src/atomic/molecules/BannerInfoCard/styles.js

var ContentContainer = styled_components_browser_esm["b" /* default */].div.withConfig({
  displayName: "styles__ContentContainer",
  componentId: "sc-1hxx7qp-0"
})(["width:auto;flex-grow:1;display:flex;flex-direction:column;justify-content:flex-start;align-items:center;margin:0px 10px;text-align:center;overflow:hidden;"]);
var LogoContainer = styled_components_browser_esm["b" /* default */].div.withConfig({
  displayName: "styles__LogoContainer",
  componentId: "sc-1hxx7qp-1"
})(["background:#ffffff;position:absolute;top:", ";left:50%;transform:translate(-50%,-50%);width:", ";height:", ";border-radius:20px;box-shadow:0 24.4px 29.9px 0 rgba(0,0,0,0.04);display:flex;flex-direction:column;justify-content:center;align-items:center;z-index:10;overflow:hidden;& img{width:100%;height:100%;}& p{color:#9cafd9;font-family:Roboto Black;font-size:24px;font-weight:bold;}"], function (props) {
  return props.bannerH ? props.bannerH : "0";
}, function (props) {
  return props.size ? props.size : "120px";
}, function (props) {
  return props.size ? props.size : "120px";
});
var ActionContainer = styled_components_browser_esm["b" /* default */].div.withConfig({
  displayName: "styles__ActionContainer",
  componentId: "sc-1hxx7qp-2"
})(["width:100%;height:65px;display:flex;flex-direction:row;justify-content:center;align-items:center;"]);
var Action = styled_components_browser_esm["b" /* default */].p.withConfig({
  displayName: "styles__Action",
  componentId: "sc-1hxx7qp-3"
})(["cursor:pointer;color:#1767f5;font-family:Roboto Medium;font-size:16px;font-weight:bold;"]);
var WrapperTitle = styled_components_browser_esm["b" /* default */].div.withConfig({
  displayName: "styles__WrapperTitle",
  componentId: "sc-1hxx7qp-4"
})(["display:block;overflow:hidden;"]);
// CONCATENATED MODULE: ./src/atomic/molecules/BannerInfoCard/index.js

var __jsx = react_default.a.createElement;






var BannerInfoCard_BannerInfoCard = function BannerInfoCard(_ref) {
  var title = _ref.title,
      actionText = _ref.actionText,
      actionCallback = _ref.actionCallback,
      cardW = _ref.cardW,
      cardH = _ref.cardH,
      border = _ref.border,
      bannerSrc = _ref.bannerSrc,
      bannerNode = _ref.bannerNode,
      bannerH = _ref.bannerH,
      logoSrc = _ref.logoSrc,
      logoText = _ref.logoText,
      logoSize = _ref.logoSize,
      children = _ref.children;
  var titleMargin = (logoSize ? parseInt(logoSize.match(/(\d+)px/)[1]) / 2 : 0) + 20;
  return __jsx(DefaultCard["a" /* default */], {
    shadow: "true",
    width: cardW,
    height: cardH,
    radius: border
  }, __jsx(ImageFrame["a" /* default */], {
    src: bannerSrc,
    frH: bannerH,
    borderRadius: "20px"
  }, bannerNode), __jsx(ContentContainer, null, title && __jsx(WrapperTitle, null, __jsx(DefaultTitle["a" /* default */], {
    size: "20px",
    margin: "".concat(titleMargin, "px 0 20px 0")
  }, title)), children), (title || children) && __jsx(Divider["a" /* default */], null), __jsx(ActionContainer, null, __jsx(Action, {
    onClick: actionCallback
  }, actionText)), (logoSrc || logoText) && __jsx(LogoContainer, {
    size: logoSize,
    bannerH: bannerH
  }, logoSrc && __jsx("img", {
    src: logoSrc,
    alt: "logo"
  }), logoText && __jsx("p", null, logoText)));
};

BannerInfoCard_BannerInfoCard.defaultProps = {
  actionText: "Action"
};
/* harmony default export */ var molecules_BannerInfoCard = __webpack_exports__["a"] = (BannerInfoCard_BannerInfoCard);

/***/ }),

/***/ "w+tp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var google_maps_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("+567");
/* harmony import */ var google_maps_react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(google_maps_react__WEBPACK_IMPORTED_MODULE_1__);

var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;



var GoogleMap = function GoogleMap(_ref) {
  var width = _ref.width,
      height = _ref.height,
      coords = _ref.coords,
      google = _ref.google,
      markerList = _ref.markerList,
      onClickMap = _ref.onClickMap,
      onDragstartMap = _ref.onDragstartMap,
      onDragendMap = _ref.onDragendMap,
      onZoomMap = _ref.onZoomMap,
      onClickMarker = _ref.onClickMarker,
      onMouseoverMarker = _ref.onMouseoverMarker;
  var renderMarkers = Object(react__WEBPACK_IMPORTED_MODULE_0__["useMemo"])(function () {
    return markerList.map(function (marker, idx) {
      return __jsx(google_maps_react__WEBPACK_IMPORTED_MODULE_1__["Marker"], {
        key: idx,
        name: marker.name,
        position: marker.coords,
        icon: marker.pinIcon ? {
          url: marker.pinIcon,
          scaledSize: new google.maps.Size(35, 35)
        } : null,
        onMouseover: function onMouseover(props, markerRef, e) {
          return onMouseoverMarker ? onMouseoverMarker(props, markerRef, e, marker.payload) : null;
        },
        onClick: function onClick(props, markerRef, e) {
          return onClickMarker ? onClickMarker(props, markerRef, e, marker.payload) : null;
        }
      });
    });
  }, [google, markerList, onClickMarker, onMouseoverMarker]);
  return __jsx(google_maps_react__WEBPACK_IMPORTED_MODULE_1__["Map"], {
    containerStyle: {
      width: width,
      height: height
    },
    initialCenter: coords,
    google: google,
    zoom: 15,
    fullscreenControl: false,
    onClick: function onClick(props, e) {
      return onClickMap ? onClickMap(props, e) : null;
    },
    onDragstart: function onDragstart(props, e) {
      return onDragstartMap ? onDragstartMap(props, e) : null;
    },
    onDragend: function onDragend(props, e) {
      return onDragendMap ? onDragendMap(props, e) : null;
    },
    onZoomChanged: function onZoomChanged(props, e) {
      return onZoomMap ? onZoomMap(props, e) : null;
    }
  }, renderMarkers);
};

GoogleMap.defaultProps = {
  markerList: [],
  coords: {
    lat: -23.498934,
    lng: -46.625435
  }
};
/* harmony default export */ __webpack_exports__["a"] = (Object(google_maps_react__WEBPACK_IMPORTED_MODULE_1__["GoogleApiWrapper"])({
  apiKey: "AIzaSyD4BJV-u9OzkDAgqkIEKiTatn5_sFs13Dk",
  language: "PT-BR"
})(GoogleMap));

/***/ })

}]);